export default {
  dictionariesLoaded: false,
  dictionaryBhUsersRoleIds: {},
  dictionaryPracticeUserRole: {},
  dictionaryFileType: {},
  dictionarySupportedFileTypes: {},
  dictionaryFeatureFlagState: {},
  dictionaryAuditableOperations: {},
  dictionaryAuditableTypes: {},
}
